import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Heart, Film, BarChart3, Shield, Mail, ArrowRight } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function SlidePostCongress() {
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-8 md:p-12 flex flex-col" data-id="element-560">
      <JourneyTimeline currentStage={5} data-id="element-561" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-5 border-l-4 border-[#C5000F] pl-6" data-id="element-562">
        <div className="flex items-center gap-3 mb-2" data-id="element-563">
          <span className="text-4xl" data-id="element-564">🔁</span>
          <h2 className="text-3xl font-bold text-[#2D2926]" data-id="element-565">
            Post Congress: Sustaining Momentum
          </h2>
        </div>
        <p className="text-xl text-[#C5000F] font-medium" data-id="element-566">
          Goal: Keep the conversation alive & move prospects down the funnel
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[0.8fr_1.2fr] gap-6 min-h-0" data-id="element-567">
        <div className="flex flex-col gap-4 overflow-auto" data-id="element-568">
          <motion.div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-569">
            <h3 className="text-base font-bold text-[#2D2926] mb-3 flex items-center gap-2" data-id="element-570">
              <span className="w-8 h-1 bg-[#C5000F] rounded-full" data-id="element-571"></span>
              Tactics
            </h3>
            <ul className="space-y-2.5" data-id="element-572">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-573">
                <Heart className="w-4 h-4 text-[#C5000F] mt-0.5 shrink-0" data-id="element-574" />
                <span className="text-gray-700 text-sm" data-id="element-575">
                  "Thank you" Snak™ with recap & highlights
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-576">
                <Film className="w-4 h-4 text-[#C5000F] mt-0.5 shrink-0" data-id="element-577" />
                <span className="text-gray-700 text-sm" data-id="element-578">
                  Personalized "what you missed" reels for rare disease sessions
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-579">
                <BarChart3 className="w-4 h-4 text-[#C5000F] mt-0.5 shrink-0" data-id="element-580" />
                <span className="text-gray-700 text-sm" data-id="element-581">
                  Polls or surveys to learn what resonated
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#C5000F]/5 p-4 rounded-xl border border-[#C5000F]/10" variants={container} initial="hidden" animate="show" data-id="element-582">
            <h3 className="text-base font-bold text-[#2D2926] mb-3 flex items-center gap-2" data-id="element-583">
              <span className="w-8 h-1 bg-[#E60012] rounded-full" data-id="element-584"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-2.5" data-id="element-585">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-586">
                <div className="w-2 h-2 rounded-full bg-[#E60012] mt-1.5 shrink-0" data-id="element-587" />
                <span className="text-gray-700 text-sm" data-id="element-588">
                  <strong className="text-[#2D2926]" data-id="element-589">Rating Cue™</strong> for
                  session feedback
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-590">
                <div className="w-2 h-2 rounded-full bg-[#E60012] mt-1.5 shrink-0" data-id="element-591" />
                <span className="text-gray-700 text-sm" data-id="element-592">
                  <strong className="text-[#2D2926]" data-id="element-593">Goto Cue™</strong> to
                  navigate between topics
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-594">
                <div className="w-2 h-2 rounded-full bg-[#E60012] mt-1.5 shrink-0" data-id="element-595" />
                <span className="text-gray-700 text-sm" data-id="element-596">
                  Output reports to support{' '}
                  <strong className="text-[#2D2926]" data-id="element-597">CRM follow-up</strong>
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        <motion.div className="flex flex-col items-center justify-center min-h-0" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-598">
          <motion.div className="flex items-center gap-2 mb-6 bg-[#2D2926] rounded-full px-4 py-1.5 shadow-sm" initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-599">
            <Mail className="w-3.5 h-3.5 text-[#E60012]" data-id="element-600" />
            <span className="text-xs font-bold text-white" data-id="element-601">
              CSL Post-Congress Follow-up
            </span>
          </motion.div>

          <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-602">
            <div className="bg-gradient-to-r from-[#E60012] to-[#C5000F] p-6 text-white text-center" data-id="element-603">
              <h3 className="text-xl font-bold mb-2" data-id="element-604">
                Thank you for visiting CSL
              </h3>
              <p className="text-sm text-white/80" data-id="element-605">
                Here are the resources you requested
              </p>
            </div>

            <div className="p-6 space-y-4" data-id="element-606">
              <div className="p-4 rounded-xl bg-gray-50 border border-gray-100 flex items-start gap-4 hover:border-[#E60012]/30 transition-colors cursor-pointer group" data-id="element-607">
                <div className="w-10 h-10 rounded-full bg-[#E60012]/10 flex items-center justify-center shrink-0 group-hover:bg-[#E60012] transition-colors" data-id="element-608">
                  <Film className="w-5 h-5 text-[#E60012] group-hover:text-white transition-colors" data-id="element-609" />
                </div>
                <div className="flex-1" data-id="element-610">
                  <h4 className="font-bold text-[#2D2926] text-sm mb-1" data-id="element-611">
                    IgA Nephropathy Symposium Recap
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-612">
                    Watch the 3-minute highlight reel
                  </p>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-300 group-hover:text-[#E60012] transition-colors self-center" data-id="element-613" />
              </div>

              <div className="p-4 rounded-xl bg-gray-50 border border-gray-100 flex items-start gap-4 hover:border-[#E60012]/30 transition-colors cursor-pointer group" data-id="element-614">
                <div className="w-10 h-10 rounded-full bg-[#E60012]/10 flex items-center justify-center shrink-0 group-hover:bg-[#E60012] transition-colors" data-id="element-615">
                  <BarChart3 className="w-5 h-5 text-[#E60012] group-hover:text-white transition-colors" data-id="element-616" />
                </div>
                <div className="flex-1" data-id="element-617">
                  <h4 className="font-bold text-[#2D2926] text-sm mb-1" data-id="element-618">
                    Clinical Data Summary
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-619">
                    Download the latest study results
                  </p>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-300 group-hover:text-[#E60012] transition-colors self-center" data-id="element-620" />
              </div>
            </div>
          </div>

          <motion.p className="text-[11px] text-gray-500 italic text-center mt-4 max-w-sm" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7
        }} data-id="element-621">
            HCPs receive personalized follow-up based on their booth
            interactions, moving them further down the funnel.
          </motion.p>
        </motion.div>
      </div>
    </div>;
}